import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSend = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M14 8L3 14L5.0625 8L3 2L14 8Z",
		stroke: "#DCFFAE",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M5 8H14",
		stroke: "#DCFFAE",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgSend;
